import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import CurrencyFormat from 'react-currency-format';
import { Tooltip,calculateContractlength, getContractStartDate, getPersonAgeByContractDate } from "../../utils";
import InsuranceTaker from '../insurance-taker'
import StartDateOptions from "../start-date-options";

const kennitala = require('kennitala')

class RislebForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                age: '',
                ageContractEnd: '',
                contractEnd: '',
                monthlyinsurance: '',
                deathbenefits: '',
                beneficiary: '',
            }
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.age = React.createRef()
        this.ageContractEnd = React.createRef()
        this.contractEnd = React.createRef()
        this.monthlyinsurance = React.createRef()
        this.deathbenefits = React.createRef()
    }

    componentDidMount () {
        if (this.props.initialValues['RISLEBcontractstartdate'] === undefined) {
            this.props.dispatch(setInfoKey({key: "RISLEBcontractstartdate", value: getContractStartDate("RISLEB").format("D.M.YYYY")}, this.props.customerId))
        }

        let info = kennitala.info(this.props.customerId)
        if (info.age > 17) {
            this.props.dispatch(setInfoKey({key: "RISLEBinsuranceTaker", value: this.props.customerId}, this.props.customerId))
        }
    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        Object.keys(errors).forEach(key => {
            switch (key) {
                case 'age':
                    let ageValue = this.props.initialValues["age"];
                    if (parseInt(ageValue) < 18) {
                        errors.age = 'Að lágmarki 18'
                        valid = false;
                    } else if (parseInt(ageValue) > 74) {
                        errors.age = 'Að hámarki 74'
                        valid = false;
                    } else {
                        errors.age = ''
                    }
                    break;
                case 'ageContractEnd':
                    let age = this.age.current.value;
                    let ageContractEndValue = this.ageContractEnd.current.value;
                    let contractLength = calculateContractlength(this.props.customerId, ageContractEndValue, this.props.initialValues["RISLEBcontractstartdate"])

                    if (contractLength < 5) {
                        errors.contractEnd = 'Að lágmarki 5'
                        valid = false;
                    } else if (contractLength > 50) {
                        errors.contractEnd = 'Að hámarki 50'
                        valid = false
                    } else if (ageContractEndValue === '') {
                        errors.ageContractEnd = 'Skilyrði að fylla út'
                        valid = false;
                    } else {
                        errors.ageContractEnd = ''
                        errors.contractEnd = ''
                    }
                    break;

                case 'monthlyinsurance':
                    let monthlyinsuranceValue = this.props.initialValues["RISLEBpayment"];
                    if (this.props.initialValues["RISLEBtype"] === "installments") {
                        if (parseInt(monthlyinsuranceValue) < 5) {
                            errors.monthlyinsurance = 'Að lágmarki 5 €'
                            valid = false;
                        } else if (monthlyinsuranceValue === '' || monthlyinsuranceValue == undefined) {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    } else {
                        if (parseInt(monthlyinsuranceValue) > 20000000) {
                            errors.monthlyinsurance = 'Að hámarki 20.000.000 €'
                            valid = false;
                        } else if (parseInt(monthlyinsuranceValue) < 25000) {
                            errors.monthlyinsurance = 'Að lágmarki 25.000 €'
                            valid = false;
                        } else if (monthlyinsuranceValue === '') {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    }
                    break;

                case 'deathbenefits':
                    if (this.props.initialValues["RISLEBdeathbenefits"] === true) {
                        let deathbenefitsValue = this.deathbenefits.current.value;
                        if (parseInt(deathbenefitsValue) < 100) {
                            errors.deathbenefits = 'Að lágmarki 100%';
                            valid = false
                        } else if (parseInt(deathbenefitsValue) > 400) {
                            errors.deathbenefits = 'Að hámarki 400%';
                            valid = false
                        } else if (deathbenefitsValue === '') {
                            errors.deathbenefits = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.deathbenefits = ''
                        }
                    } else {
                        errors.deathbenefits = ''
                    }
                    break;
                case 'insurancetaker':
                    let insuranceTakerValue = this.props.initialValues['RISLEBinsuranceTaker'];
                    if (insuranceTakerValue === undefined || insuranceTakerValue === "") {
                        errors.insurancetaker = 'Velja þarf tryggingartaka'
                        valid = false;
                    } else {
                        errors.insurancetaker = ''
                    }
                    break;
                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.checked }, this.props.customerId))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeLargeNumberInput(value, name) {
        this.props.dispatch(setInfoKey({ key: name, value: value }, this.props.customerId))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }
    onClickConfirm(event) {
        let validate = this.validateForm()
        
        if (this.props.isAdult && this.props.initialValues['RISLEBinsuranceTaker'] === undefined) {
            this.props.dispatch(setInfoKey({ key: 'RISLEBinsuranceTaker', value: this.props.customerId }, this.props.customerId))
        }

        if (validate) {
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }
    }
    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    render() {
        const { customerId, customers, active, initialValues } = this.props
        const contractAge = getPersonAgeByContractDate(customerId, initialValues["RISLEBcontractstartdate"])
        const displayAge = contractAge !== null ? contractAge : initialValues["age"]

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.age.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ris-contract-age-${customerId}`} className="col-sm-8 col-form-label">
                            Samningsaldur
                            {this.state.errors.age.length > 0 ?
                                 <span className="error"> ({this.state.errors.age}) </span> : ''
                            }
                            <Tooltip placement="bottom" text={"Samningsaldur umsækjanda miðast við upphafsdag samnings.  Ef <strong>meira en 183 dagar</strong> eru liðnir frá síðasta afmæli á upphafsdegi er aldurinn námundaður upp um eitt ár."} />
                        </label>
                        <div className="col-sm-4">
                            <input  id={`ris-contract-age-${customerId}`} name="contract-age" type="number" className="form-control px-2 text-sm-right" value={displayAge} disabled />
                            <input type="hidden" ref={this.age} id={`ris-age-${customerId}`} name="age" className="form-control px-2 text-sm-right" value={initialValues["age"]} />
                        </div>
                    </div>
                    <div className={`form-row align-items-center`}>
                        <label className="col-sm-8 col-form-label">
                            Upphaf samnings
                        </label>
                        <div className="col-sm-4 text-right">
                            <StartDateOptions
                                startDate={getContractStartDate("RISLEB").format("D.M.YYYY")}
                                selectedDate={initialValues["RISLEBcontractstartdate"]}
                                contractDateKey={"RISLEBcontractstartdate"}
                                customerId={customerId}
                                disabled={initialValues.rislebConfirm}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                    <div className={`${this.state.errors.ageContractEnd.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`risleb-age-by-contract-end-${customerId}`} className="col-sm-8 col-form-label">
                            Aldur við lok samnings
                            {this.state.errors.ageContractEnd.length > 0 ?
                                 <span className="error"> ({this.state.errors.ageContractEnd}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            <input ref={this.ageContractEnd} id={`risleb-age-by-contract-end-${customerId}`} name="RISLEBageByContractEnd" type="number" className="form-control  text-sm-right px-2" onChange={this.onChangeTextInput} value={initialValues["RISLEBageByContractEnd"]} max={initialValues["age"] + 50} disabled={initialValues.rislebConfirm} />
                        </div>
                    </div>
                    <div className={`${this.state.errors.contractEnd.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`leb-contract-length-${customerId}`} className="col-sm-8 col-form-label">
                            Lengd samnings (ár)
                            {this.state.errors.contractEnd.length > 0 ?
                                 <span className="error"> ({this.state.errors.contractEnd}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            <input id={`leb-contract-length-${customerId}`} type="number" className="form-control text-sm-right px-2" onChange={this.onChangeTextInput} value={calculateContractlength(customerId, initialValues["RISLEBageByContractEnd"], this.props.initialValues["RISLEBcontractstartdate"])} disabled />
                        </div>
                    </div>
                    <div className={`${this.state.errors.monthlyinsurance.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <div className="col-sm-8">
                            <select className="custom-select col-sm-4" id={`risleb-type-${customerId}`} name="RISLEBtype" onChange={this.onChangeSelectValue} value={initialValues["RISLEBtype"]} disabled={initialValues.rislebConfirm} >
                                <option value="installments">Iðgjald</option>
                                <option value="insuranceamount">Vátryggingarupphæð</option>
                            </select>
                            {this.state.errors.monthlyinsurance.length > 0 ?
                                 <span className="error"> ({this.state.errors.monthlyinsurance}) </span> : ''
                            }
                        </div>

                        <div className="col-12 col-sm-4 text-right currency">
                            <CurrencyFormat 
                                ref={this.monthlyinsurance}
                                thousandSeparator={"."} 
                                id={`risleb-insurance-${customerId}`}
                                name="RISLEBpayment"
                                type="text" 
                                className="form-control"                               
                                value={initialValues["RISLEBpayment"]} 
                                disabled={initialValues.rislebConfirm}
                                decimalSeparator={','} 
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.onChangeLargeNumberInput(value, "RISLEBpayment")
                                }}
                            />
                            {initialValues["RISLEBtype"] === "insuranceamount" && <div>25.000-20.000.000 €.</div>}
                            {initialValues["RISLEBtype"] === "installments" && <div>Lágmarksiðgjald eru 5€.</div>}
                            
                        </div>
                    </div>
                    <div className={`${this.state.errors.deathbenefits.length > 0 ? 'error' : ''} form-row checkbox-row align-items-center`}>
                        <div className="col-8">
                            <div className="col-form-label">
                                <label className="caption-label" htmlFor={`risleb-deathbenefits-accident-${customerId}`}>Dánarbætur vegna slyss</label>
                                {this.state.errors.deathbenefits.length > 0 ?
                                    <span className="error"> ({this.state.errors.deathbenefits}) </span> : ''
                                }
                            </div>
                            <input type="checkbox" id={`risleb-deathbenefits-accident-${customerId}`} name="RISLEBdeathbenefits" onChange={this.onChangeCheckbox} checked={initialValues["RISLEBdeathbenefits"]} disabled={initialValues.rislebConfirm} />
                            <label htmlFor={`risleb-deathbenefits-accident-${customerId}`} className="col-sm-10 col-form-label"></label>
                        </div>
                        {initialValues["RISLEBdeathbenefits"] === true &&
                            <div className="col-4 percentage">
                                <input ref={this.deathbenefits} id={`leb-death-insurance-${customerId}`} name="RISLEBdeathinsurance" type="text" className="form-control" onChange={this.onChangeTextInput} value={initialValues["RISLEBdeathinsurance"]} disabled={initialValues.rislebConfirm} />
                                <div>100-400%</div>
                            </div>
                        }
                    </div>
                    <div className="form-row align-items-center">
                        <div className="col-sm-8">
                            <label htmlFor={`risleb-payment-frequency-${customerId}`} className="col-sm-8 col-form-label pl-0">Greiðslutíðni</label>
                        </div>
                        <div className="col-sm-4 text-right">
                            <select className="custom-select col-sm-4" id={`risleb-payment-frequency-${customerId}`} name="RISLEBpaymentfrequency" onChange={this.onChangeSelectValue} value={initialValues["RISLEBpaymentfrequency"]} disabled={initialValues.rislebConfirm} >
                                <option value="monthly">Mánaðarlega</option>
                                <option value="quarterly">Ársfjórðungslega</option>
                                <option value="every6months">Hálfsárslega</option>
                                <option value="yearly">Árlega</option>
                               
                            </select>
                        </div>
                    </div>
                    <InsuranceTaker fieldName={`RISLEBinsuranceTaker`} customerId={customerId} customers={customers} initialValues={initialValues} disabled={initialValues.rislebConfirm}/>
                </form>
                <div className="col-12 text-right button-container">
                    {initialValues.rislebConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="rislebConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="rislebConfirm" onClick={this.onClickConfirm}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default RislebForm